import type { CopybookTemplatePreset } from '../store/copybookStore'

export const COPYBOOK_TEMPLATES: CopybookTemplatePreset[] = [
  {
    id: 'basic-practice',
    name: '基礎硬筆練習',
    description: 'A4 直式，田字格，適合單字與短句練習。',
    gridType: 'tian',
    showTrace: true,
    traceType: 'hollow',
    showStroke: false,
    showPhonetic: false,
    showCorrection: false,
    colsPerRow: 10,
    gridSize: 18,
    subtitle: '硬筆練習',
  },
  {
    id: 'copybook-trace',
    name: '描紅練習',
    description: 'A4 直式，先看範字再描紅，適合入門跟寫。',
    gridType: 'mi',
    showTrace: true,
    traceType: 'solid',
    showStroke: false,
    showPhonetic: false,
    showCorrection: false,
    colsPerRow: 9,
    gridSize: 20,
    subtitle: '描紅字帖',
  },
  {
    id: 'poetry-copying',
    name: '詩詞抄寫',
    description: 'A4 直式，適合詩詞歌賦與短篇抄寫。',
    gridType: 'blank',
    showTrace: false,
    traceType: 'hollow',
    showStroke: false,
    showPhonetic: false,
    showCorrection: false,
    colsPerRow: 12,
    gridSize: 15,
    subtitle: '詩詞歌賦',
  },
  {
    id: 'article-copying',
    name: '文章抄寫',
    description: 'A4 直式，較密集的格線配置，適合長文。',
    gridType: 'huigong',
    showTrace: false,
    traceType: 'hollow',
    showStroke: false,
    showPhonetic: false,
    showCorrection: false,
    colsPerRow: 12,
    gridSize: 14,
    subtitle: '常見文章',
  },
  {
    id: 'copying-practice',
    name: '臨帖練習',
    description: 'A4 直式，田字格，一字一空，看左臨右，適合自主臨寫。',
    gridType: 'tian',
    showTrace: false,
    traceType: 'hollow',
    showStroke: false,
    showPhonetic: false,
    showCorrection: false,
    colsPerRow: 10,
    gridSize: 18,
    subtitle: '臨帖練習',
    copyInterval: true,
  },
  {
    id: 'wide-copying-practice',
    name: '寬版臨帖練習',
    description: 'A4 直式，田字格，每字後留兩格以上，適合放大練習與重複書寫。',
    gridType: 'tian',
    showTrace: false,
    traceType: 'hollow',
    showStroke: false,
    showPhonetic: false,
    showCorrection: false,
    colsPerRow: 10,
    gridSize: 18,
    subtitle: '寬版臨帖',
    copyInterval: true,
    copyBlankCount: 2,
  },
  {
    id: 'row-copying-practice',
    name: '行間臨帖練習',
    description: 'A4 直式，田字格，一行範例字、一行空格，適合按行通篇對照抄寫。',
    gridType: 'tian',
    showTrace: false,
    traceType: 'hollow',
    showStroke: false,
    showPhonetic: false,
    showCorrection: false,
    colsPerRow: 10,
    gridSize: 18,
    subtitle: '行間臨帖',
    copyRowInterval: true,
    copyRowBlankCount: 1,
  },
  {
    id: 'blank-practice',
    name: '空白臨摹',
    description: 'A4 直式，只保留格線，適合自由書寫。',
    gridType: 'blank',
    showTrace: false,
    traceType: 'hollow',
    showStroke: false,
    showPhonetic: false,
    showCorrection: false,
    colsPerRow: 10,
    gridSize: 18,
    subtitle: '自由臨摹',
  },
]

